window.__forceSmoothScrollPolyfill__ = true;
import smoothscroll from './vendor/smoothscroll';
smoothscroll.polyfill();

import config from './config';
import breakpoint from './breakpoint';

breakpoint.init();
config.init();

import debounce from './debounce';

import ClickHandler from './ClickHandler.class';
// import VideoHandler from './VideoHandler.class';
import HeroHandler from './HeroHandler.class';
import ScrollToHandler from './ScrollToHandler.class';
import FixedMenuHandler from './FixedMenuHandler.class';
// import ItemListAjaxHandler from './ItemListAjaxHandler.class';
// import SliderHandler from './SliderHandler.class';
import ParallaxHandler from './ParallaxHandler.class';
import TimetableHandler from './TimetableHandler.class';
import ObfEmlHandler from './ObfEmlHandler.class';
import InViewHandler from './InViewHandler.class';
import LottieHandler from './LottieHandler.class';
// import MapHandler from './MapHandler.class';
// import CookieHandler from './CookieHandler.class';
// import MagneticButtonHandler from './MagneticButtonHandler.class';
import OverlayHandler from './OverlayHandler.class';
import HorizontalLoopHandler from './HorizontalLoopHandler.class';

import ContactFormHandler from './ContactForm.class';
import FormHandler from './Form.class';

const handler = {
    click: new ClickHandler(),
    // video: new VideoHandler(),
    hero: new HeroHandler(),
    fixedMenu: new FixedMenuHandler(),
    // itemListAjax: new ItemListAjaxHandler(),
    // slider: new SliderHandler(),
    parallax: new ParallaxHandler(),
    timetable: new TimetableHandler(),
    obfEml: new ObfEmlHandler(),
    inView: new InViewHandler(),
    lottie: new LottieHandler(),
    // cookie: new CookieHandler(),
    // map: new MapHandler(),
    // magenticButton: new MagneticButtonHandler(),
    overlay: new OverlayHandler(),
    contact: new ContactFormHandler(),
    form: new FormHandler(),
    hloop: new HorizontalLoopHandler(),
};

handler.scrollTo = new ScrollToHandler({ fixedMenu: handler.fixedMenu });

window.addEventListener('resize', () => {
    document.documentElement.className =
        document.documentElement.className.replace(
            /\bno-resized\b/g,
            'resized'
        );
});
window.addEventListener(
    'resize',
    debounce(() => {
        document.documentElement.className =
            document.documentElement.className.replace(
                /\bresized\b/g,
                'no-resized'
            );
    }, 500)
);
